import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";

export const invoiceManagementRouter: RouteRecordRaw[] = [
    {
        path: "/invoice",
        name: "Invoice",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/invoice/applyFor",
        meta: {
            title: "发票管理"
        },
        children: [
            {
                path: "applyFor",
                name: "ApplyForBilling",
                component: () => import("@/views/pages/invoiceManagement/applyForBilling/index.vue"),
                meta: {
                    title: "申请开票",
                    keepAlive: true,
                    pageType: PAGE_TYPE.LIST.code
                }
            },
            {
                path: "apply/add",
                name: "ApplyForAdd",
                component: () => import("@/views/pages/invoiceManagement/applyForBilling/form.vue"),
                meta: {
                    title: "新增开票",
                    activeMenu: "ApplyForBilling",
                    isNotShowHeader: true,
                    hidden: true,
                    keepAlive: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code
                }
            },
            {
                path: "apply/edit",
                name: "ApplyForEdit",
                component: () => import("@/views/pages/invoiceManagement/applyForBilling/form.vue"),
                meta: {
                    title: "修改开票",
                    isNotShowHeader: true,
                    activeMenu: "ApplyForBilling",
                    hidden: true,
                    keepAlive: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code
                }
            },
            {
                path: "apply/detail",
                name: "ApplyForDetail",
                component: () => import("@/views/pages/invoiceManagement/applyForBilling/detail.vue"),
                meta: {
                    title: "开票详情",
                    activeMenu: "ApplyForBilling",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.DETAIL.code,
                    hidden: true
                }
            },
            {
                path: "bill",
                name: "Bill",
                component: () => import("@/views/pages/invoiceManagement/billManagement/index.vue"),
                meta: {
                    title: "开票管理",
                    keepAlive: true,
                    pageType: PAGE_TYPE.LIST.code
                }
            },
            {
                path: "bill/detail",
                name: "BillDetail",
                component: () => import("@/views/pages/invoiceManagement/billManagement/detail.vue"),
                meta: {
                    title: "开票详情",
                    activeMenu: "Bill",
                    isNotShowHeader: true,
                    hidden: true
                }
            },
            {
                path: "bill/add",
                name: "BillAdd",
                component: () => import("@/views/pages/invoiceManagement/billManagement/form.vue"),
                meta: {
                    title: "新增开票",
                    activeMenu: "Bill",
                    isNotShowHeader: true,
                    hidden: true,
                    keepAlive: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code
                }
            },
            {
                path: "bill/edit",
                name: "BillEdit",
                component: () => import("@/views/pages/invoiceManagement/billManagement/form.vue"),
                meta: {
                    title: "修改开票",
                    isNotShowHeader: true,
                    activeMenu: "Bill",
                    hidden: true,
                    keepAlive: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code
                }
            }
        ]
    }
];

export default invoiceManagementRouter;
